import { Link } from "react-router-dom";
import { Home, ArrowLeft } from "lucide-react";
import Seo from "@/components/Seo";

export default function NotFound() {
    return (
        <section className="min-h-[60vh] flex items-center bg-slate-50">
            <Seo title="Page not found" description="That page doesn't exist." path="/404" noIndex />
            <div className="container-x text-center py-20">
                <div className="text-7xl sm:text-8xl font-display font-bold text-navy-900 tracking-tight">404</div>
                <h1 className="mt-4 text-2xl sm:text-3xl font-display font-bold text-navy-900">Page not found</h1>
                <p className="mt-3 text-slate-600 max-w-md mx-auto">That page seems to have wandered off. Let&apos;s get you back on track.</p>
                <div className="mt-7 flex flex-wrap justify-center gap-3">
                    <Link to="/" className="btn-primary"><Home className="w-4 h-4" /> Home</Link>
                    <button onClick={() => window.history.back()} className="btn-secondary"><ArrowLeft className="w-4 h-4" /> Go back</button>
                </div>
            </div>
        </section>
    );
}
